import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getProcess = () => http({
    url: ENDPOINTS.secretariat.secretariat.dictionaryAll,
    method: 'get',
    // params: {
    //     positionId: positionId
    // }
}).then((response) => (response.data))